import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { Observable } from 'rxjs';
   //import { FormsModule } from '@angular/forms';
import { async } from 'q';


@Component({
  selector: 'app-advertise',
  templateUrl: './advertise.component.html',
  styleUrls: ['./advertise.component.css']
})
export class AdvertiseComponent implements OnInit {
  
  constructor(private db:AngularFireDatabase) { }
   adver: Observable<any[]>;
   //msg: string;
  ads : string[];
  name: string = '';
   async ngOnInit(){
    var snap = await this.db.database.ref("/TextAd").once('value');
    // console.log(snap.val());
    this.ads = snap.val();
    this.adver = this.db.list("TextAd").valueChanges();
    
  }

  addText(msg:string){
    //var text = document.getElementById('advertise').value;
    alert(msg);
  }

}


